export default __webpack_public_path__ + "static/media/10.a4988ee9.svg";